import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import { AuthProvider } from './contexts/AuthContext';
import { SHOW_CAREERS } from './lib/features';
import ProtectedRoute from './components/ProtectedRoute';
import Nav from './components/Nav';
import Footer from './components/Footer';

import Home from './pages/Home';
import Photos from './pages/Photos';
import Album from './pages/Album';
import { CareersHub, CareersLayout } from './pages/Careers';
import CV from './pages/CV';
import Brief from './pages/Brief';
import Portfolio from './pages/Portfolio';
import Work from './pages/Work';
import Projects from './pages/Projects';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin — no Nav */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

          {/* Public — with Nav */}
          <Route path="*" element={
            <>
              <Nav />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Work />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/photos" element={<Photos />} />
                <Route path="/album/:slug" element={<Album />} />
                {SHOW_CAREERS ? (
                  <>
                    <Route path="/careers" element={<CareersHub />} />
                    <Route path="/careers" element={<CareersLayout />}>
                      <Route path="cv" element={<CV />} />
                      <Route path="brief" element={<Brief />} />
                      <Route path="portfolio" element={<Portfolio />} />
                    </Route>
                    {/* Legacy redirect */}
                    <Route path="/cv" element={<Navigate to="/careers/cv" replace />} />
                  </>
                ) : (
                  <>
                    {/* Careers hidden — send old links home */}
                    <Route path="/careers/*" element={<Navigate to="/" replace />} />
                    <Route path="/cv" element={<Navigate to="/" replace />} />
                  </>
                )}
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
